import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { PickerTranslations } from '@shared/utils/translations';
import { debounceTime, distinctUntilChanged } from 'rxjs';

@Component({
    selector: 'syn-picker-input',
    templateUrl: './picker-input.component.html',
})
export class PickerInputComponent implements OnInit {

    @Input() translations: PickerTranslations;

    @Output() load = new EventEmitter<string>();

    public termInput: FormControl;

    public strictSearch = false;

    public async ngOnInit(): Promise<void> {
        this.termInput = new FormControl('');

        this.termInput.valueChanges
            .pipe(
                debounceTime(600),
                distinctUntilChanged()
            )
            .subscribe((term) => {
                this.load.emit(term);
            });
    }

    public switchStrictMode(): void {
        this.strictSearch = !this.strictSearch;
        this.load.emit(this.termInput.value);
    }

    public clearInput(): void {
        this.termInput.setValue('');
    }
}
